<template>
  <article class="registration-steps" v-if="formData">
    <h2 class="registration-steps__title">Passo 3</h2>

    <div class="registration-steps__wrapper">
      <p class="registration-steps__message registration-steps__message--uppercase">
        Confira seus dados
      </p>

      <ul class="registration-steps__review">
        <li class="review-item">
          <header class="review-item__header">
            <h5 class="review-item__title">Valor da consulta</h5>
          </header>
          <article class="review-item__body">
            <strong class="review-item__value">R$ {{formData.specialtyPrice}}</strong>&ensp;(para as consultas dos pacientes Dr.Conecta)
          </article>
        </li>

        <li class="review-item">
          <header class="review-item__header">
            <h5 class="review-item__title">Dias de atendimento</h5>
          </header>
          <article class="review-item__body">
            <ul class="list-unstyled">
              <li v-for="(period, $index) in formData.exclusiveDays" :key="$index">
                <strong>{{fn_FROM_WEEKDAY($index)}}</strong>,
                <span v-for="(time, $index) in period" :key="$index">
                  das {{time.periodStart}} às {{time.periodEnd}}<template v-if="$index !== period.length - 1">, </template>
                </span>
              </li>
            </ul>
          </article>
        </li>

        <li class="review-item tile">
          <header class="review-item__header">
            <h5 class="review-item__title">Tempo médio de consulta</h5>
          </header>
          <article class="review-item__body">
            <strong class="review-item__value">{{ interval | TO_HOUR_MINUTE_FORMAT }}</strong>
          </article>
        </li>
      </ul>

      <button @click="$router.push({name: 'RegisterFinish'})" class="btn btn-primary">Avançar</button>
    </div>
  </article>
</template>

<script>
export default {
  data () {
    return {
      formData: null
    }
  },
  computed: {
    getWeekdays () {
      return this.$store.getters.getSteps[2].selectedDays
    },
    interval () {
      const hours = parseInt(this.formData.appointmentInterval.split(':')[0]) * 60
      const minutes = parseInt(this.formData.appointmentInterval.split(':')[1])
      return hours + minutes
    }
  },
  mounted () {
    this.$http.get(`/doctor/doctor_office/${this.$route.params.id}/agenda_setting`, this.$store.getters.getAuthHeader).then(
      (res) => {
        this.formData = res.data
        this.fn_HIDE_PROGRESS()
      }
    ).catch(
      (err) => {
        console.log(err)
        this.fn_HIDE_PROGRESS()
      }
    )
  },
  filters: {
    TO_HOUR_MINUTE_FORMAT (period) {
      let hours = (Math.floor(period / 60) > 0) ? `${Math.floor(period / 60)}h` : ''
      let minutes = (period % 60 > 0) ? `${`0${period % 60}`.substr(-2)}min` : ''
      return `${hours}${minutes}`
    }
  }
}
</script>
